import {ReactComponent as TrashIcon} from '../../media/icon-trash.svg';
import {useStore} from '../../../store';
import React, {MouseEvent} from 'react';
import {Link} from 'react-router-dom';

type Props = {
  value: number;
  data: {
    id: number;
    groupId: string;
    itemId: string;
  };
};

const DeleteSubProductRenderer = (props: Props) => {
  const dispatchDeleteSubProduct = useStore((state) => state.dispatchDeleteSubProduct);

  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    const isConfirmed = window.confirm(`Are you sure you'd like to delete this sub-product?`);

    if (!isConfirmed) return;

    dispatchDeleteSubProduct({
      id: props.data.id,
      groupId: props.data.groupId
    });
  };

  return (
    <button className='btn' onClick={onClick} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}}>
      <TrashIcon style={{width: '2rem'}}/>
    </button>
  );
};

export default DeleteSubProductRenderer;